type Props = {
  className: string;
  color: string;
  height: number;
  width: number;
};

const InputPrefix = ({ className = '', color = '#000', height = 20, width = 20 }: Props) => (
  <svg id="svg2" className={className} height={height} width={width} viewBox="71.692 24.814 360.729 325.667" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="115.192"
      y="64.04"
      width="466.675"
      height="250.712"
      style={{
        stroke: color,
        paintOrder: 'stroke',
        fillOpacity: 0,
        fillRule: 'nonzero',
        fill: 'none',
        strokeLinejoin: 'round',
        strokeWidth: '32px',
      }}
    ></rect>
    <rect
      x="143.963"
      y="92.982"
      width="212.286"
      height="193.26"
      style={{
        fill: color,
      }}
    ></rect>
  </svg>
);

export default InputPrefix;
